import { defineMessages } from 'react-intl';

const messages = defineMessages({
  tooltip_MTTD: {
    id: 'um6bIJ',
    defaultMessage: 'Mean Time To Detect (MTTD)',
  },
  invalidTextMTTD: {
    id: 'uPkz5+',
    defaultMessage: 'Please provide a valid % of time spent on finding issues',
  },
  welcome_msg_1: {
    id: 'Qmmja7',
    defaultMessage: 'See how much IBM Databand could save you',
  },
  triggertext_MTTR: {
    id: 'nDy/Jc',
    defaultMessage: '% of time your data engineers spend resolving data issues',
  },
  footnote_one: {
    id: 'Pcnhj8',
    defaultMessage:
      'The results shown are based on certain assumptions, including the following: average data engineer salary of $150K/year; results are based on the US data. The results of this tool are provided for illustrative purposes only, to help you determine whether to consider Databand as a business solution. The results are not based on actual data or statistical modeling, and may not be accurate or applicable to you. Actual results will vary based on your particular business conditions, usage and configurations and environment, among other factors. Results from the calculator should not be relied upon, and are not a guarantee or commitment regarding any potential or actual financial results or other benefits you may achieve. Actual ROI & benefit will vary depending on individual client configurations and conditions.',
  },
  'thankyou.details-selected-bp': {
    id: 'BkHBGW',
    defaultMessage: 'Selected Business Partner',
  },
  triggertext_MTTD: {
    id: 'agvoky',
    defaultMessage:
      '% of time your data engineers spend finding the root cause of data issues',
  },
  focus_level_group_name: {
    id: 'WoFKlr',
    defaultMessage:
      'How much focus is being placed on data observability initiatives in the next 12 months?',
  },
  three_year_savings: {
    id: 'Wfel04',
    defaultMessage: 'Estimated 3-year dollar savings',
  },
  contact_us: {
    id: 'WnQ/AZ',
    defaultMessage: 'Contact us',
  },
  'thankyou.details-consent-bp': {
    id: 'oZz635',
    defaultMessage:
      'I consent to IBM providing my business contact information',
  },
  hours_saved_year: {
    id: 'Z9y77b',
    defaultMessage: 'Estimated hours saved per year',
  },
  invalidTextDataEngineers: {
    id: 'Kn0ApE',
    defaultMessage: 'Please provide a valid number of data of engineers',
  },
  triggertext_data_engineers: {
    id: '2M5at9',
    defaultMessage: 'Number of Data Engineers',
  },
  'thankyou.title': {
    id: 'aYIUar',
    defaultMessage: 'Thank you!',
  },
  scoping_text: {
    id: 'VZ+CMD',
    defaultMessage:
      'For this calculator, we use the assumption that data engineers will see a 2x increase in efficiency resolving issues. However, typically Databand customers typically see up to 5x increase in efficiency with throughput increases over time.',
  },
  request_a_quote: {
    id: 'aAghQx',
    defaultMessage: 'Request a quote now',
  },
  focus_level_thankyou: {
    id: 'WHQZfY',
    defaultMessage:
      'Focus level being placed on data observability initiatives in the next 12 months',
  },
  'thankyou.details-title': {
    id: 'NWIE97',
    defaultMessage: 'Request details',
  },
  tooltip_focus_level: {
    id: 'ul/mwY',
    defaultMessage:
      'Select "Low" if your organization is in beginning stages of data modernization journey (5% of time building custom logic), "Medium" if there are specific deliverables around monitoring of pipelines, (15%), and "High" if your data organization has data/pipeline quality as a main objective (30%)',
  },
  'thankyou.subtitle': {
    id: 'PwjLGb',
    defaultMessage: 'We have received your request',
  },
  'return-to-estimator': {
    id: 'KFM268',
    defaultMessage: 'Return to Databand web page',
  },
  tooltip_data_engineers: {
    id: 'NluU0H',
    defaultMessage:
      'Also include other employees that may be performing tasks below',
  },
  tooltip_MTTR: {
    id: 'ibuKen',
    defaultMessage: 'Mean Time To Resolve (MTTR)',
  },
  invalidTextMTTR: {
    id: '4TgdCi',
    defaultMessage:
      'Please provide a valid % of time spent on resolving issues',
  },
  yearly_savings: {
    id: 'K8Ciw6',
    defaultMessage: 'Estimated yearly dollar savings',
  },
  preferred_bp: {
    id: '9Auwhe',
    defaultMessage: 'Preferred IBM Business Partner',
  },
});

export default messages;
